import { Fragment, lazy, Suspense, useContext, useEffect, useState } from 'react';
import { APButton, APIcon } from '@ap/design-system';
import useCurrentUserCan from '../../../users/services/useCurrentUserCan';
import { UserPermission } from '../../../users/enums/UserPermission';
import { EventReportingContext, ReportsFilters } from '../../pages/EventReporting';
import { StyledStack } from './styles';
import useBreakpointDown from '../../../../template/hooks/useBreakpointDown';

const DialogReports = lazy(() => import('../ReportsDialog/ReportsDialog'));

function ReportingCommands() {
  const { filters } = useContext(EventReportingContext);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const canReport = useCurrentUserCan(UserPermission.REPORTING);

  const isMobile = useBreakpointDown('md');

  const handleClose = async () => {
    setDialogOpen(false);
  };

  useEffect(() => {
    const disabled =
      filters.find((e) => e.id === ReportsFilters.MASTER_EVENTS)?.value.length === 0 &&
      filters.find((e) => e.id === ReportsFilters.SUB_EVENTS)?.value.length === 0;

    setDisabled(disabled);
  }, [filters]);

  if (!canReport) {
    return null;
  }

  return (
    <Fragment>
      <StyledStack direction='row' alignItems='center' spacing={3}>
        <APButton
          startIcon={<APIcon name='Analytics' fontSize='small' />}
          onClick={() => setDialogOpen(true)}
          disabled={disabled}
        >
          {isMobile ? 'Generate' : 'Generate reports'}
        </APButton>
      </StyledStack>
      <Suspense fallback={<Fragment />}>{dialogOpen && <DialogReports onClose={handleClose} />}</Suspense>
    </Fragment>
  );
}

export default ReportingCommands;
